export default __webpack_public_path__ + "static/media/Group 107 (1).9e3b53b6.svg";